import React, {  useMemo } from "react";

import './style.scss';
import NGMainContainer from "../modules/ng-bmp/NGMainContainer";
import TNMainContainer from "../modules/tns-bmp/TNMainContainer";
import SAMainContainer from "../modules/sa-bmp/SAMainContainer";
import AMMainContainer from "../modules/am-bmp/AMMainContainer";
import {Footer} from "../Footer";
import MTNMainContainer from "../modules/mtn-bmp/MTNMainContainer";
import { mtn_logo_white } from "../assets/mtn";
import { logo_white } from "../assets";

const componentPerCountry = {
  ng: NGMainContainer,
  am: AMMainContainer,
  tn: TNMainContainer,
  sa: SAMainContainer,
  mtnads: MTNMainContainer,
  airtelads: NGMainContainer,
}

const MainContainer = () => {

  const Component = useMemo(() => {
    if (window.location.hostname.split('.')[0] === 'localhost' || window.location.hostname.split('.')[0] === 'bmp-dev') {
      return componentPerCountry['mtnads'];
    }
    // @ts-ignore
    return componentPerCountry[window.location.hostname.split('.')[0] || 'am'];
  }, []);

  const footerProps = useMemo(() => {
    const prefix = window.location.hostname.split('.')[0];
    if (prefix === 'ng' || prefix === 'airtelads') {
      return {
        classes: {
          footer: 'footer-tn',
        },
        compact: true,
        companyDetailsPerCountry: (
          <div className='footer-company-details-trusted'>
            <p className='trusted-by-airtel'>In Partnership With telcos</p>
          </div>
        ),
        linkedInURL: 'https://www.linkedin.com/company/intent-ai-nigeria/',
        phone: '+234 902 243 4093',
        formattedPhoneNum: '+2349022434093',
      };
    }

    if (prefix === 'localhost' || prefix === 'bmp-dev' || prefix === 'mtnads') {
      return {
        classes: {
          footer: 'footer-mtn',
        },
        partnerLogo: mtn_logo_white,
        phone: '+374 (55) 756078',
        formattedPhoneNum: '+37455756078',
        companyDetailsPerCountry: (
          <div className="footer-company-details-trusted-mtn">
            <p className="trusted-by-mtn">Powered by</p>
            <img width={130} height={40} src={logo_white as string} alt="Logo" />
          </div>
        )
      }
    }

    if (prefix === 'tn') {
      return {
        classes: {
          footer: 'footer-tn',
          socialIcon: 'social-icon-tn',
        },
      }
    }

    if (prefix === 'sa') {
      return {
        classes: {
          footer: 'footer-sa',
          socialIcon: 'social-icon-tn',
        },
      }
    }

    return {
      phone: '+374 (55) 756078',
      formattedPhoneNum: '+37455756078',
    }
  }, []);

  return (
    <div
      className={"main-container dsp"}
    >
      <main>
        <Component />
      </main>
      <Footer
        facebookURL='https://www.facebook.com/intent.ai.global'
        linkedInURL='https://www.linkedin.com/company/intent-ai/'
        privacyPolicyURL='/privacy-policy'
        termsOfServiceURL='/terms-of-service'
        {...footerProps}
      />
    </div>
  );
}

export default MainContainer